import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, LoadingStateProvider, LoginStateProvider, StudyProgressProvider } from './Context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <App />
  
  <React.StrictMode>
    <LoginStateProvider>
      <StudyProgressProvider>
        <ThemeProvider>
          <LoadingStateProvider>
            <App />
          </LoadingStateProvider>
        </ThemeProvider>
      </StudyProgressProvider>
    </LoginStateProvider>
  </React.StrictMode>
);

reportWebVitals();